
import * as DashboardConstants from '../../Dashboards/DashboardConstants';


export const botSummaryReportTableHeaders = [
    {
        key: 'botId',
        header: DashboardConstants.BotId
    },
    {
        key: 'leadPlatform',
        header: DashboardConstants.LeadPlatform
    },
    {
        key: 'subArea',
        header: DashboardConstants.SubArea
    },
    {
        key: 'processName',
        header: DashboardConstants.ProcessName
    },
    {
        key: 'geo',
        header: DashboardConstants.Geo
    },
    {
        key: 'processCritical',
        header: DashboardConstants.ProcessCritical
    },
    {
        key: 'requestedBy',
        header: DashboardConstants.RequestedBy
    },
    {
        key: 'deliveryModel',
        header: DashboardConstants.DeliveryModel
    },
    {
        key: 'supportStatus',
        header: DashboardConstants.SupportStatus
    },
    {
        key: 'completions',
        header: DashboardConstants.Completions
    },
    // {
    //     key: 'stopped',
    //     header: DashboardConstants.Stopped
    // },
    {
        key: 'schMisses',
        header: DashboardConstants.SchMisses
    },
    {
        key: 'terminations',
        header: DashboardConstants.Terminations
    },
    {
        key: 'reruns',
        header: DashboardConstants.ReRuns
    },
    {
        key: 'totalRuns',
        header: DashboardConstants.TotalRuns
    },
    {
        key: 'successRate',
        header: DashboardConstants.SuccessRatePercent
    },
    // {
    //     key: 'comments',
    //     header: DashboardConstants.Comments
    // },
];

export const performanceTrendHeaders = [
    {
        key: 'ProcessName',
        header: DashboardConstants.AutomataName
    },
    // {
    //     key: 'queueName',
    //     header: DashboardConstants.QueueName
    // },
    {
        key: 'NoofItem',
        header: DashboardConstants.NoOfItems
    },
    {
        key: 'CompletedItem',
        header: DashboardConstants.Completed
    },
    {
        key: 'ItemPending',
        header: DashboardConstants.Pending
    },
    {
        key: 'running',
        header: DashboardConstants.Running
    },
    {
        key: 'BusinessException',
        header: DashboardConstants.BusinessEx
    },
    {
        key: 'SystemException',
        header: DashboardConstants.SystemEx
    },
    {
        key: 'dFTE',
        header: DashboardConstants.dFTE
    },
    {
        key: 'Speed',
        header: DashboardConstants.Speed
    },
    {
        key: 'UPT',
        header: DashboardConstants.UPT
    },
    {
        key: 'Others',
        header: DashboardConstants.Others
    },
    {
        key: 'botaccuracy',
        header: DashboardConstants.AutomataAccuracy
    }

]

export const queuePerformanceHeaders = [
    {
        key: 'QueueName',
        header: DashboardConstants.QueueName
    },
    {
        key: 'AvgProcessTime',
        header: DashboardConstants.AvgProcessingTimeMin
    }
]

export const RepeatedTerminationBotsHeaders = [
    {
        key: 'automataName',
        header: DashboardConstants.AutomataName
    },
    {
        key: 'leadPlatform',
        header: DashboardConstants.LeadPlatform
    },
    {
        key: 'subArea',
        header: DashboardConstants.SubArea
    },
    {
        key: 'geoName',
        header: DashboardConstants.GeoName
    },
    {
        key: 'criticality',
        header: DashboardConstants.Criticality
    },
    {
        key: 'requestedBy',
        header: DashboardConstants.RequestedBy
    },
    {
        key: 'deliveryModel',
        header: DashboardConstants.DeliveryModel
    },
    {
        key: 'repeatedTerminations',
        header: DashboardConstants.RepeatedTerminations
    },
    {
        key: 'scheduleFrequency',
        header: DashboardConstants.ScheduleFrequency
    },
    {
        key: 'lastExecution',
        header: DashboardConstants.LastExecutionTime
    }
];

export const queueAverageHeaders = [
    {
        key: 'QueueName',
        header: DashboardConstants.QueueName
    },
    {
        key: 'AvgHandlingTime',
        header: DashboardConstants.AvgHandlingTimeMin
    }
]
